import { Alert } from "@mui/material";
import { flatten } from "lodash-es";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import VehicleOperations, {
  VehicleOperationsTabs,
} from "@/common/components/EntityComposed/Operations/VehicleOperations";
import { ViewVariant } from "@/common/ts/layout";
import { DamageCostEvaluationDto } from "@/core/api/generated/v1";

interface Props {
  damageCostEvaluation: DamageCostEvaluationDto;
}

export default function RelatedOperationsTabContent({ damageCostEvaluation }: Props) {
  return (
    <PageTabContent gap={0}>
      <Alert severity='info'>
        Here you can see related operations. For instance, operations for the same damages or
        operations that are in the same context.
      </Alert>

      <VehicleOperations
        vehicleId={damageCostEvaluation.vehicle?.id}
        anyVehicleDamageIds={flatten(
          damageCostEvaluation.items
            ?.map((x) => x.damages?.map((y) => y.damage?.id || "") || [])
            .filter(Boolean),
        )}
        displayProps={{
          header: false,
          filters: false,
          viewVariant: ViewVariant.Tab,
        }}
        excludeTabs={[
          VehicleOperationsTabs.DamageCostEvaluations,
          VehicleOperationsTabs.AccessoryChecks,
        ]}
      />
    </PageTabContent>
  );
}
